import { Global, css } from '@emotion/react'

export default function ParagraphEditorStyle() {
  return (
    <Global
      styles={css`
        .paragraph-editor {
          outline: 0;
          min-height: 22px;
          padding: 0 20px;

          *:not(li) {
            margin-bottom: 0 !important;
          }

          .paragraph-editor-image-upload-loading-box {
            width: 400px;
            height: 200px;
            background: rgba(98, 105, 153, 0.06);
            display: flex;
            align-items: center;
            justify-content: center;
          }

          &.disabled {
            .paragraph-split-mark {
              opacity: 0;
              pointer-events: none;
            }
          }

          .paragraph-split-mark {
            min-height: auto;
            margin-bottom: 0;
            width: 0;
            &:hover {
              width: 100%;
              .line {
                border-color: #7b61ff;
              }
            }
          }
        }
      `}
    />
  )
}
